export type SearchPopUpCustomersParams = {
  headquarter?: number
  ids?: string[]
  search?: string
  clientSettingsIds?: string[]
  limit?: number
  offset?: number
  reqMethod?: string
}

export const SearchPopUpCustomers =
  ({ RestService, HandleError }: any) =>
  async ({
    headquarter,
    ids,
    search,
    clientSettingsIds,
    limit = 100,
    offset = 0,
    reqMethod = 'get',
  }: SearchPopUpCustomersParams) => {
    const req: any = { limit, offset }
    if (search) {
      req.search = search
    }
    if (ids) {
      req.ids = ids
    }
    if (headquarter) {
      req.hq = headquarter
    }
    if (clientSettingsIds) {
      req.clientSettingsIds = clientSettingsIds
    }

    try {
      // NOTE: allow specifying req method for this api call; if
      // req includes many customer ids, prefer "post" method as it
      // avoids nginx errors caused by URI too large
      if (reqMethod === 'post') {
        return await RestService.post('/pop-up-customers/search', req)
      } else {
        return await RestService.get('/pop-up-customers', req)
      }
    } catch (error) {
      HandleError({ error })

      return []
    }
  }

export const GetPopUpCustomer =
  ({ RestService, HandleError }: any) =>
  async (id: string) => {
    try {
      return await RestService.get(`/pop-up-customers/${id}`)
    } catch (error) {
      HandleError({ error })

      return undefined
    }
  }

export const SavePopUpCustomer =
  ({ RestService, UIService, HandleError }: any) =>
  async (customer: any) => {
    try {
      let resp
      if (customer.id) {
        resp = await RestService.put(
          `/pop-up-customers/${customer.id}`,
          customer,
        )
      } else {
        resp = await RestService.post('/pop-up-customers/admin', customer)
      }
      UIService.FlashMessage.displaySuccessMessage(
        `Customer ${customer.email} successfully ${
          customer.id ? 'updated' : 'created'
        }`,
      )

      return resp
    } catch (error) {
      HandleError({ error })

      return false
    }
  }

export const UpsertAccountRole =
  ({ RestService, UIService, HandleError }: any) =>
  async (req: any) => {
    try {
      const customer = await RestService.put(
        '/group-orders/client-settings/account-role',
        { ...req, version: '2' },
      )
      UIService.FlashMessage.displaySuccessMessage(
        `Customer role successfully updated`,
      )

      return customer
    } catch (error) {
      HandleError({ error })

      return false
    }
  }

export const DeletePopUpCustomer =
  ({ RestService, UIService, HandleError }: any) =>
  async ({ id, email }: any) => {
    const doDelete = await UIService.ConfirmationModal.show({
      text: `Are you sure you want to delete customer with email: "${email}"?`,
    })
    if (doDelete) {
      try {
        await RestService.delete(`/pop-up-customers/${id}`)
      } catch (error) {
        HandleError({ error })

        return false
      }

      return true
    }

    return false
  }
